import { Flex } from 'antd';
import { useTranslation } from 'translations/hooks';

import Button from 'ui/button';

import styles from './index.module.scss';

export const BulkStatusSelectionBar = ({
  onCancel,
  onValidate,
}: {
  onCancel: () => void;
  onValidate: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <Flex justify="flex-end" gap={8} className={styles.bar}>
      <Button onClick={onCancel}>{t('common.cancel')}</Button>
      <Button type="primary" onClick={onValidate}>
        {t('common.confirm')}
      </Button>
    </Flex>
  );
};
